import { convertDateToUnix, getLastNDays } from 'src/utils/utils';
import axios from './index';

export const _filterLogs = (reqObj) => {
  const {
    data: { issuerID, userID, fromDate, toDate }
  } = reqObj;
  return axios.get(
    `public/v1/app/get-history/${issuerID}/${userID}/${fromDate}/${toDate}`
  );
};

export const _getAllLogs = () => {
  return axios.get(`public/v1/app/get-history/-/-/0/999999999999`);
};

export const _getCustomers = () => {
  return axios.get(`public/v1/app/get-customer`);
};

export const getSelfRequest = (filterObj = {}) => {
  const { from, to } = filterObj;
  return axios.get(
    `v1/admins/activity-logs/get/self/activity-logs/${
      from || convertDateToUnix(getLastNDays(30))
    }/${to || convertDateToUnix(getLastNDays(0))}`
  );
};

export const getSelfIssuerLogRequest = (filterObj = {}) => {
  const { from, to } = filterObj;
  return axios.get(
    `v1/issuer-staffs/activity-logs/get/self/activity-logs/${
      from || convertDateToUnix(getLastNDays(30))
    }/${to || convertDateToUnix(getLastNDays(0))}`
  );
};

export const getAdminLogsRequest = (filterObj = {}) => {
  const { adminID, from, to } = filterObj;
  return axios.get(
    `v1/admins/activity-logs/get/activity-logs/${adminID || '-'}/${
      from || convertDateToUnix(getLastNDays(30))
    }/${to || convertDateToUnix(getLastNDays(0))}`
  );
};

export const getAdminIssuerLogsRequest = (filterObj = {}) => {
  const { issuerID, issuerStaffID, from, to } = filterObj;
  return axios.get(
    `v1/admins/activity-logs/get/issuer/activity-logs/${issuerID || '-'}/${
      issuerStaffID || '-'
    }/${from || convertDateToUnix(getLastNDays(30))}/${
      to || convertDateToUnix(getLastNDays(0))
    }`
  );
};

export const getAdminIssuerStaffLogsRequest = (filterObj = {}) => {
  const { issuerID, issuerStaffID, from, to } = filterObj;
  return axios.get(
    `v1/issuer-staffs/activity-logs/get/self/issuer-staff/activity-logs/${
      issuerStaffID || '-'
    }/${from || convertDateToUnix(getLastNDays(30))}/${
      to || convertDateToUnix(getLastNDays(0))
    }`
  );
};
